import N8nNavigationDropdown from './NavigationDropdown.vue';

export default N8nNavigationDropdown;
